import React from "react";
import { Skeleton, Grid, Stack } from "@mui/material";

const BidsSkeleton = () => {
  return (
    <Grid
      container
      style={{
        borderBottom: "1px solid #EEEBEF",
        marginTop: "20px",
        paddingBottom: "20px",
      }}
      // alignItems="center"
    >
      <Grid item sm={1}></Grid>
      <Grid item sm={2}>
        <Skeleton variant="circular" animation="wave" width={80} height={80} />
      </Grid>
      <Grid item sm={8}>
        <Skeleton variant="text" animation="wave" width="100%" height={40} />
        <Skeleton variant="text" animation="wave" width="100%" height={40} />
        <Skeleton
          variant="rectangular"
          animation="wave"
          width="100%"
          height={60}
        />

        <Skeleton variant="text" animation="wave" width="100%" height={40} />
        <Skeleton
          variant="rectangular"
          animation="wave"
          width="100%"
          height={80}
        />
      </Grid>
    </Grid>
  );
};

export default BidsSkeleton;
